import { render, staticRenderFns } from "./m2_sidebar.vue?vue&type=template&id=c4e061e2&"
import script from "./m2_sidebar.vue?vue&type=script&lang=js&"
export * from "./m2_sidebar.vue?vue&type=script&lang=js&"
import style0 from "./m2_sidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports